<template>
  <layout>
    <rdkm-title>
      {{ $t('Шаблоны отчетов') }}
    </rdkm-title>
    <div class="tile">      
      <rdkm-grid :state="query">
        <grid-column name="EDIT" cell="edit-cell"></grid-column>
        <grid-column name="typeName" :title="$t('Тип')"></grid-column>
      </rdkm-grid>
    </div>
  </layout>
</template>

<script>
import Grid from "../../components/grid/Grid.vue";
import GridColumn from "../../components/grid/GridColumn.vue";

export default {
  name: "ReportTemplates",
  props: ["query"],
  components: {
    "rdkm-grid": Grid,
    "grid-column": GridColumn
  }
};
</script>
